import React, { useEffect, useState } from "react";
import {
  stuacademicyearlist,
  stuclasslist,
  studivisionlist,
  stufeetypelist,
  vehstagelist,
} from "../../../services/master";
import {
  academylist,
  createfeestructure,
  deletefeestructure,
  listfeestructure,
} from "../../../services/admin";
import Select from "react-select";
import { toast } from "react-toastify";
import { studentfilter } from "../../../services/student";
import Swal from "sweetalert2";
import { Modal, Button } from "react-bootstrap";

export default function Feestructure() {
  const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  // Build the 12 months of an academic year ("2026-2027") as April→March,
  // i.e. Apr..Dec in the first year, Jan..Mar in the second.
  const academicMonths = (label) => {
    const years = String(label || "").match(/\d{4}/g);
    if (!years) return [];
    const y1 = parseInt(years[0], 10);
    const y2 = years[1] ? parseInt(years[1], 10) : y1 + 1;
    const seq = [
      [4, y1], [5, y1], [6, y1], [7, y1], [8, y1], [9, y1], [10, y1], [11, y1], [12, y1],
      [1, y2], [2, y2], [3, y2],
    ];
    return seq.map(([mo, yr]) => ({
      value: `${yr}-${String(mo).padStart(2, "0")}`,
      label: `${MONTH_NAMES[mo - 1]} ${yr}`,
    }));
  };

  const [ayear, setAYear] = useState("");
  const [alist, setAList] = useState([]);

  const [clist, setCList] = useState([]);

  const [dlist, setDList] = useState([]);

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");

  const [feetype, setFeeType] = useState("");
  const [flist, setFList] = useState([]);
  const [ftlist, setFTList] = useState([]);

  const [stglist, setStgList] = useState([]);

  // Add Individual Modal States
  const [showIndividualModal, setShowIndividualModal] = useState(false);
  const [individualForm, setIndividualForm] = useState({
    academy: "",
    academicYear: "",
    feeType: "",
    feeTypeRoute: "",
    class: "",
    section: "",
    student: "",
    admissionNumber: "",
    feeAmount: "",
    stage: "",
    monthly: false,
    selectedMonths: []
  });
  const [stulist, setStuList] = useState([]);
  const [individualFormErrors, setIndividualFormErrors] = useState({});
  const [individualStageList, setIndividualStageList] = useState([]);

  const [loading, setLoading] = useState(false);
  const [spush, setSpush] = useState(true);
  // Card-level monthly setting: applies to every row in the bulk fee table.
  const [monthlyAll, setMonthlyAll] = useState(false);
  // Explicit months the fee applies to, as "YYYY-MM" (lets you skip holiday months).
  const [selectedMonths, setSelectedMonths] = useState([]);
  // Single category-wise fee entry
  const [spushInd, setSpushInd] = useState(true);
  const [filterProduct, setFilterProduct] = useState([
    { id: 0, class: "", sec: "", stuid: "", stgid: "", amt: "" },
  ]);
  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listfees(e, ayear, feetype);
      listyear(e)
    } else {
      setAcaID("");
      listfees("", ayear, feetype);
      listyear("");
    }
  }
  function listyear(aid) {
    setAList([]);
    setAYear("");
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    stuacademicyearlist(temp).then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].aca_year,
            });
          }
          setAList(arr);
        }
      }
    });

    stufeetypelist(temp).then((res) => {
      if (res.status === true) {
        setFTList(res.data);
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].fee_type,
            });
          }
          setFList(arr);
        }

        const temp1 = new FormData();
        if (localStorage.getItem("Role") === "1" && aid !== "") {
          temp1.append("academy_id", aid.value);
        }
        vehstagelist(temp1).then((res1) => {
          if (res1.status === true) {
            let arr1 = [];
            if (res1.data.length > 0) {
              for (let i = 0; i < res1.data.length; i++) {
                arr1.push({
                  value: res1.data[i].id,
                  label: res1.data[i].vehroute_stage,
                });
              }
              setStgList(arr1);
            }
          }
        });
      }
    });


  }
  useEffect(() => {


    stuclasslist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].class_name,
            });
          }
          setCList(arr);
        }
      }
    });

    studivisionlist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].name,
            });
          }
          setDList(arr);
        }
      }
    });




    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setACList(arr);
        }
      }
    });


    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
                listyear(arr[0]);
                setAYear(localStorage.getItem("AYear"));
              }
            }

          }
        }
      });
    } else {
      listyear("");
    }
  }, []);

  const handleAddRow = () => {
    setExamerr(false);
    setFilterProduct([
      ...filterProduct,
      { id: 0, class: "", sec: "", stuid: "", stgid: "", amt: "" },
    ]);
  };

  const handleRemoveRow = (index, rid) => {
    if (rid !== 0) {
      deletefeestructure(rid).then((res) => {
        if (res.status === true) {
          toast.success(res.message);
          listfees(acaid, ayear, feetype);
        } else {
          Swal.fire({
            icon: 'warning',
            text: res.message,
            confirmButtonText: 'OK'
          });
        }
      });
    } else {
      setFilterProduct(filterProduct.filter((_, i) => i !== index));
    }
  };
  const classOptions = clist.map((item) => ({
    value: item.value,
    label: item.label,
  }));
  const handleClassChange = (index, classOptions) => {
    const updatedRows = [...filterProduct];
    updatedRows[index].class = classOptions;
    setFilterProduct(updatedRows);
    // liststudent(updatedRows);
  };

  const sectionOptions = dlist.map((item) => ({
    value: item.value,
    label: item.label,
  }));
  const handleSecChange = (index, selectedOptions) => {
    const updatedProduct = [...filterProduct];
    updatedProduct[index].sec = selectedOptions;
    setFilterProduct(updatedProduct);
    // liststudent(updatedProduct);

  };
  const handleStuChange = (index, selectedOptions) => {
    const updatedProduct = [...filterProduct];
    updatedProduct[index].stuid = selectedOptions;
    setFilterProduct(updatedProduct);

  };

  const stageOptions = stglist.map((item) => ({
    value: item.value,
    label: item.label,
  }));
  const handleStageChange = (index, stageOptions) => {
    const updatedRows = [...filterProduct];
    updatedRows[index].stgid = stageOptions;
    setFilterProduct(updatedRows);
  };
  const handleAmtChange = (index, e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      const updatedRows = [...filterProduct];
      updatedRows[index].amt = e.target.value;
      setFilterProduct(updatedRows);
    }

  };



  const [errormsg, setErrMsg] = useState("");
  const [examerr, setExamerr] = useState(false);

  function handleSave(e) {
    e.preventDefault();
    setErrMsg("");
    let valid = "";
    if (localStorage.getItem("Role") === "1") {
      if (acaid === "") {
        valid = "Please Select Academy";
        setErrMsg("Please Select Academy");
      }
    }
    if (valid === "") {
      if (ayear !== "") {
        if (feetype !== "") {
          setExamerr(true);
          const isClass = filterProduct.every((row) => row.class !== "");
          const isSec = filterProduct.every(
            (row) => Array.isArray(row.sec) && row.sec.length > 0
          );

          const isStg = filterProduct.every(
            (row) => Array.isArray(row.stgid) && row.stgid.length > 0
          );
          const isAmt = filterProduct.every((row) => row.amt !== "");

          if (monthlyAll && selectedMonths.length === 0) {
            setErrMsg("Please select at least one month for the monthly fee");
            return;
          }

          if (((isClass && isSec) || isStg) && isAmt) {
            setLoading(true);

            const temp = new FormData();
            if (localStorage.getItem("Role") === "1" && acaid !== "") {
              temp.append("academy_id", acaid.value);
            }
            temp.append("academic_year", ayear);
            temp.append("feetype", feetype);
            temp.append("count", filterProduct.length);
            temp.append("type", 1);

            for (let i = 0; i < filterProduct.length; i++) {
              const selectedClass = filterProduct[i].class;
              if (Array.isArray(selectedClass)) {
                const sectionValues = selectedClass
                  .map((option) => option.value)
                  .join(",");
                temp.append("class_id_" + [i + 1], sectionValues);
              } else {
                temp.append("class_id_" + [i + 1], '');
              }

              const selectedSections = filterProduct[i].sec;
              if (Array.isArray(selectedSections)) {
                const sectionValues = selectedSections
                  .map((option) => option.value)
                  .join(",");
                temp.append("section_" + [i + 1], sectionValues);
              } else {
                temp.append("section_" + [i + 1], '');
              }


              const selectedStage = filterProduct[i].stgid;
              if (Array.isArray(selectedStage)) {
                const stageValues = selectedStage
                  .map((option) => option.value)
                  .join(",");
                temp.append("stage_" + [i + 1], stageValues);
              } else {
                temp.append("stage_" + [i + 1], '');
              }

              temp.append("amount_" + [i + 1], filterProduct[i].amt);

              // Card-level monthly setting applies to every row.
              temp.append("frequency_" + [i + 1], monthlyAll ? "monthly" : "one_time");
              temp.append("months_" + [i + 1], monthlyAll ? selectedMonths.join(",") : "");
            }
            temp.append("send_push", spush ? 1 : 0);

            createfeestructure(temp).then((res) => {
              if (res.status === true) {
                setLoading(false);
                setExamerr(false);
                toast.success(res.message);
                if (localStorage.getItem("Role") === "1" && acaid !== "") {
                  listfees(acaid, ayear, feetype);
                }
                window.location.reload();
              } else {
                setLoading(false);
                setExamerr(false);
                setErrMsg(res.data.join(", "));
              }
            });
          }
        } else {
          setErrMsg("Please Select Fee Type");
          valid = "Please Select Fee Type";
        }
      } else {
        setErrMsg("Please Select Academic Year");
        valid = "Please Select Academic Year";
      }
    }
  }
  const [ftype, setFType] = useState("");
  async function listfees(lid, lyear, ltype) {
    setFilterProduct([{ id: 0, class: "", sec: "", stuid: "", stgid: "", amt: "" }]);
    setAYear(lyear);
    setFeeType(ltype);
    const sdata = ftlist.find((item) => item.id == ltype);
    setFType(sdata ? sdata.feestype : "");

    const temp1 = new FormData();
    if (localStorage.getItem("Role") === "1" && lid !== "") {
      temp1.append("academy_id", lid.value);
    }
    const res1 = await vehstagelist(temp1);
    let stageList = [];

    if (res1.status === true && res1.data.length > 0 && sdata) {
      const sdata1 = res1.data.filter((item) => item.route_id == sdata.fee_route);
      for (let i = 0; i < sdata1.length; i++) {
        stageList.push({
          value: sdata1[i].id,
          label: sdata1[i].vehroute_stage,
        });
      }
      setStgList(stageList); // Set stage list for future use
    }

    if (lyear !== "" && ltype !== "") {
      const temp = new FormData();
      if (localStorage.getItem("Role") === "1" && lid !== "") {
        temp.append("academy_id", lid.value);
      }
      temp.append("academic_year", lyear);
      temp.append("feetype", ltype);

      // Now call listfeestructure AFTER vehstagelist has completed
      const res = await listfeestructure(temp);
      if (res.status === true) {
        setFilterProduct([]);
        let arr = [];

        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            const row = res.data[i];

            // Stage-based rows (transport / van fees): class_id is empty but
            // a stage is set. Map them to the stage column instead of skipping.
            if (row.stage !== null && row.stage !== "" && row.stage != 0) {
              const stgOption = stageList.find(
                (option) => option.value == row.stage
              );
              arr.push({
                id: row.id,
                class: [],
                sec: [],
                stuid: "",
                stgid: stgOption ? [stgOption] : [],
                amt: row.amount,
              });
              continue;
            }

            // Skip category-wise rows (class_id 0) — they're not class/section based
            if (row.class_id == 0 || row.class_id == null) continue;
            const matchedOption = dlist.find(
              (option) => option.value == row.section
            );
            const matOption = clist.find(
              (option) => option.value == row.class_id
            );
            const stgOption = stageList.find(
              (option) => option.value == row.stage
            );

            arr.push({
              id: row.id,
              class: matOption ? [matOption] : [],
              sec: matchedOption ? [matchedOption] : [],
              stuid: "",
              stgid: stgOption ? [stgOption] : [],
              amt: row.amount,
            });
          }
          setFilterProduct(arr);

          // Card-level monthly setting is shared by all rows; derive it from the saved months.
          const monthlyRow = res.data.find((r) => r.fee_months && String(r.fee_months).trim() !== "");
          setMonthlyAll(!!monthlyRow);
          setSelectedMonths(
            monthlyRow && monthlyRow.fee_months
              ? String(monthlyRow.fee_months).split(",").map((m) => m.trim()).filter((m) => m !== "")
              : []
          );
          // liststudent(arr); // Uncomment if needed
        }
      }
    }
  }
  //   const [stulist, setStuList] = useState([]);
  //  function liststudent(fpdt){
  //     const cl = Array.isArray(fpdt.class) ? fpdt.class.map(option => option.value).join(",") : "";
  //     const se = Array.isArray(fpdt.sec) ? fpdt.sec.map(option => option.value).join(",") : "";

  //      const temp = new FormData();
  //       temp.append("year", ayear);
  //       temp.append("classid", cl);
  //       temp.append("sectionid", se);
  //       if(localStorage.getItem("Role") === "1" && acaid !== ""){
  //         temp.append("academy", acaid.value);
  //       }
  //       studentfilter(temp).then((res) => {
  //         if (res.status === true) {
  //           let arr = [];
  //         //   setStuPath(res.data.path);
  //         //   setSList(res.data.details);
  //           if (res.data.details.length > 0) {
  //             for (let i = 0; i < res.data.details.length; i++) {
  //               arr.push({
  //                 value: res.data.details[i].id,
  //                 label: res.data.details[i].username + " - " + res.data.details[i].student_name,
  //               });
  //             }
  //           }
  //           setStuList(arr);
  //         }
  //       });
  //   }

  // Individual Modal Functions
  const handleShowIndividualModal = () => {
    setShowIndividualModal(true);

    // Get fee type route if fee type is available
    let feeTypeRoute = "";
    if (feetype) {
      const selectedFeeType = ftlist.find((item) => item.id == feetype);
      if (selectedFeeType) {
        feeTypeRoute = selectedFeeType.feestype;
      }
    }

    setIndividualForm({
      academy: acaid,
      academicYear: ayear,
      feeType: feetype,
      feeTypeRoute: feeTypeRoute,
      class: "",
      section: "",
      student: "",
      admissionNumber: "",
      feeAmount: "",
      stage: "",
      monthly: false,
      selectedMonths: []
    });
    setIndividualFormErrors({});

    // Load stages if fee type is 3 (transport)
    if (feeTypeRoute == 3) {
      loadIndividualStages();
    }
  };

  const handleCloseIndividualModal = () => {
    setShowIndividualModal(false);
    setIndividualForm({
      academy: "",
      academicYear: "",
      feeType: "",
      class: "",
      section: "",
      student: "",
      admissionNumber: "",
      feeAmount: "",
      stage: "",
      monthly: false,
      selectedMonths: []
    });
    setIndividualFormErrors({});
    setStuList([]);
    setIndividualStageList([]);
  };

  const [admdet, setAdmDet] = useState("");
  const handleIndividualFormChange = (field, value) => {
    setIndividualForm(prev => ({
      ...prev,
      [field]: value
    }));

    // Clear specific field error when user starts typing
    if (individualFormErrors[field]) {
      setIndividualFormErrors(prev => ({
        ...prev,
        [field]: ""
      }));
    }
    if (field === "admissionNumber") {
      const temp = new FormData();
      temp.append("admission", value);
      if (localStorage.getItem("Role") === "1" && individualForm.academy !== "") {
        temp.append("academy", individualForm.academy.value);
      }
      studentfilter(temp).then((res) => {
        if (res.status === true) {
          let student = Array.isArray(res.data.details) ? res.data.details[0] : res.data.details;
          setAdmDet(student);
        }
      });

    }
    if (field === "student") {
      setAdmDet("");
    }

    let feeTypeRou = "";
    if (field === 'feeType') {
      setIndividualStageList([]);
      setIndividualForm(prev => ({ ...prev, feeTypeRoute: "" }));

      const selectedFeeType = ftlist.find((item) => item.id == value);
      if (selectedFeeType) {
        feeTypeRou = selectedFeeType.feestype;
        setIndividualForm(prev => ({ ...prev, feeTypeRoute: feeTypeRou }));

      }
    }

    // Load students when class and section are selected
    if (field === 'section' && individualForm.class && value) {
      loadStudentsForIndividual(individualForm.class, value);
    }

    // Load stages when fee type is changed to 3
    if (field === 'feeType' && feeTypeRou == 3) {
      loadIndividualStages();
    } else if (field === 'feeType' && feeTypeRou != 3) {
      setIndividualStageList([]);
      setIndividualForm(prev => ({ ...prev, stage: "" }));
    }
  };

  function loadadmdetails(ldata) {
    const temp = new FormData();
    temp.append("admission", ldata);
    if (localStorage.getItem("Role") === "1" && individualForm.academy !== "") {
      temp.append("academy", individualForm.academy.value);
    }
    studentfilter(temp).then((res) => {
      if (res.status === true) {
        let student = Array.isArray(res.data.details) ? res.data.details[0] : res.data.details;
        setAdmDet(student);
      }
    });
  }

  const loadIndividualStages = async () => {
    const selectedFeeType = ftlist.find((item) => item.id == individualForm.feeType);

    const temp1 = new FormData();
    if (localStorage.getItem("Role") === "1" && individualForm.academy !== "") {
      temp1.append("academy_id", individualForm.academy.value);
    }

    const res1 = await vehstagelist(temp1);
    let stageList = [];

    if (res1.status === true && res1.data.length > 0 && selectedFeeType) {
      const sdata1 = res1.data.filter((item) => item.route_id == selectedFeeType.fee_route);
      for (let i = 0; i < sdata1.length; i++) {
        stageList.push({
          value: sdata1[i].id,
          label: sdata1[i].vehroute_stage,
        });
      }
    }
    setIndividualStageList(stageList);
  };

  const loadStudentsForIndividual = (classId, sectionId) => {
    const temp = new FormData();
    temp.append("year", individualForm.academicYear);
    temp.append("class", classId.value);
    temp.append("section", sectionId.value);
    if (localStorage.getItem("Role") === "1" && individualForm.academy !== "") {
      temp.append("academy", individualForm.academy.value);
    }

    studentfilter(temp).then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label: res.data.details[i].username + " - " + res.data.details[i].student_name,
            });
          }
        }
        setStuList(arr);
      }
    });
  };

  const [merrormsg, setMErrMsg] = useState("");

  const handleIndividualSubmit = () => {
    const errors = {};
    setMErrMsg("");
    if (localStorage.getItem("Role") === "1" && !individualForm.academy) {
      errors.academy = "Academy is required";
    }
    if (!individualForm.academicYear) {
      errors.academicYear = "Academic Year is required";
    }
    if (!individualForm.feeType) {
      errors.feeType = "Fee Type is required";
    }

    // Validate based on fee type
    if (individualForm.feeTypeRoute == 3) {
      // For transport fee (type 3), only stage is required
      if (!individualForm.stage) {
        errors.stage = "Stage is required for transport fee";
      }
    } else {
      if (individualForm.admissionNumber == "") {
        if (!individualForm.class) {
          errors.class = "Class is required";
        }
        if (!individualForm.section) {
          errors.section = "Section is required";
        }
      }
      // Validate either student selection OR admission number
      if (!individualForm.student && !individualForm.admissionNumber) {
        errors.student = "Either select a student or enter admission number";
        errors.admissionNumber = "Either select a student or enter admission number";
      }
    }

    if (!individualForm.feeAmount) {
      errors.feeAmount = "Fee amount is required";
    }

    if (individualForm.monthly && (individualForm.selectedMonths || []).length === 0) {
      errors.selectedMonths = "Select at least one month for the monthly fee";
    }

    if (Object.keys(errors).length > 0) {
      setIndividualFormErrors(errors);
      setMErrMsg(errors.selectedMonths || "");
      return;
    }
    setLoading(true);
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && individualForm.academy !== "") {
      temp.append("academy_id", individualForm.academy?.value);
    }
    temp.append("academic_year", individualForm.academicYear);
    temp.append("feetype", individualForm.feeType);
    temp.append("type", 2);
    if (individualForm.admissionNumber != "") {
      temp.append("class_id", admdet.class_id);
      temp.append("section", admdet.section_id);
      temp.append("student_id", admdet.id);
    } else {
      temp.append("class_id", individualForm.class?.value);
      temp.append("section", individualForm.section?.value);
      temp.append("student_id", individualForm.student?.value);
    }


    temp.append("stage", individualForm.stage);
    temp.append("amount", individualForm.feeAmount);
    temp.append("frequency", individualForm.monthly ? "monthly" : "one_time");
    temp.append("months", individualForm.monthly ? (individualForm.selectedMonths || []).join(",") : "");
    temp.append("send_push", spushInd ? 1 : 0);

    createfeestructure(temp).then((res) => {
      if (res.status === true) {
        setLoading(false);
        toast.success(res.message);
        handleCloseIndividualModal();
      } else {
        setLoading(false);
        setMErrMsg(res.data.join(", "));
      }
    });

  };
  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Fee Structure</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Fee Module</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Fee Structure
          </li>
        </ol>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h2 className="main-content-title tx-24 mg-b-5">
                    Select Fee Type
                  </h2>
                </div>
                <div className="card-body">
                  <div className="row">
                    {localStorage.getItem("Role") === "1" && (
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Select Academy{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <Select
                            className="default-select"
                            placeholder="Select Academy"
                            value={acaid}
                            options={aclist}
                            onChange={handleAcademy}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                        </div>
                      </div>
                    )}
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-6">
                        <label className="form-label">
                          Academic Year<span className="text-danger"> *</span>
                        </label>
                        <select
                          className="default-select form-control wide"
                          onChange={(e) =>
                            listfees(acaid, e.target.value, feetype)
                          }
                          value={ayear}
                        >
                          <option value="" disabled>
                            Select Academic Year
                          </option>
                          {alist.map((item) => (
                            <option value={item.value} key={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-6">
                        <label className="form-label">
                          Fee Type<span className="text-danger"> *</span>
                        </label>
                        <select
                          className="default-select form-control wide"
                          onChange={(e) =>
                            listfees(acaid, ayear, e.target.value)
                          }
                          value={feetype}
                        >
                          <option value="" disabled>
                            Select Fee Type
                          </option>
                          {flist.map((item) => (
                            <option value={item.value} key={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                  </div>
                  {/* <p className="text-muted mb-0" style={{ fontSize: "12px" }}>
                    Students of the selected category get the <b>Category Amount</b>; everyone else
                    gets the normal amount entered per class/section below.
                  </p> */}
                  {errormsg !== "" && (
                    <span className="text-danger">{errormsg}</span>
                  )}
                </div>
              </div>
            </div>

            <div className="col-lg-12 mt-2">
              <div className="card custom-card mg-b-20">
                <div className="card-body">
                  <div className="card-header border-bottom-0 pt-0 ps-0 pe-0 d-flex">
                    <div className="col-lg-6">
                      <h2 className="main-content-title tx-24 mg-b-5">
                        Enter Fee Structure
                      </h2>{" "}
                    </div>
                    <div className="col-lg-6 text-end">
                      <button
                        className="btn btn-secondary mt-1 me-2"
                        onClick={handleShowIndividualModal}
                      >
                        <i className="fa fa-user"></i> Add Individual
                      </button>
                      <button
                        className="btn btn-success mt-1"
                        onClick={handleAddRow}
                      >
                        {" "}
                        <i className="fa fa-plus"></i> Add
                      </button>
                    </div>
                  </div>
                  {/* <div className="mb-2 mt-1">
                    <input
                      type="checkbox"
                      className="styled-checkbox"
                      id="feePushCheckbox"
                      checked={spush}
                      onChange={(e) => setSpush(e.target.checked)}
                    /> Send Push Notification
                  </div> */}

                  {/* Monthly applies to every row below */}
                  {(() => {
                    const ayearLabel = (alist.find((a) => String(a.value) === String(ayear)) || {}).label || "";
                    const monthOpts = academicMonths(ayearLabel);
                    return (
                      <div className="mb-3 mt-1 p-2 border rounded">
                        <label style={{ cursor: "pointer" }}>
                          <input
                            type="checkbox"
                            className="styled-checkbox"
                            id="feeMonthlyCheckbox"
                            checked={monthlyAll}
                            onChange={(e) => {
                              const c = e.target.checked;
                              setMonthlyAll(c);
                              if (c && selectedMonths.length === 0) {
                                setSelectedMonths(monthOpts.map((o) => o.value));
                              }
                            }}
                          /> Monthly <span className="text-muted tx-12">(applies to all rows below — untick any holiday month)</span>
                        </label>
                        {monthlyAll && (
                          <div className="mt-2">
                            {monthOpts.length === 0 ? (
                              <span className="text-danger tx-12">Select an academic year first.</span>
                            ) : (
                              <>
                                <div className="mb-2">
                                  <button type="button" className="btn btn-sm btn-success me-2"
                                    onClick={() => setSelectedMonths(monthOpts.map((o) => o.value))}>
                                    Select all
                                  </button>
                                  <button type="button" className="btn btn-sm btn-danger"
                                    onClick={() => setSelectedMonths([])}>
                                    Clear
                                  </button>
                                  <span className="text-muted tx-12 ms-2">{selectedMonths.length} selected</span>
                                </div>
                                <div className="d-flex flex-wrap" style={{ gap: "6px 16px" }}>
                                  {monthOpts.map((m) => (
                                    <label key={m.value} style={{ cursor: "pointer", minWidth: "90px" }}>
                                      <input
                                        type="checkbox"
                                        className="styled-checkbox"
                                        checked={selectedMonths.includes(m.value)}
                                        onChange={(e) => {
                                          if (e.target.checked) {
                                            setSelectedMonths([...selectedMonths, m.value]);
                                          } else {
                                            setSelectedMonths(selectedMonths.filter((v) => v !== m.value));
                                          }
                                        }}
                                      /> {m.label}
                                    </label>
                                  ))}
                                </div>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })()}

                  <div className="table-responsive tasks">
                    <table className="table card-table table-vcenter text-nowrap mb-0  border">
                      <thead>
                        <tr>
                          {ftype != 3 &&
                            <>
                              <th className="wd-lg-20p text-center">Class</th>
                              <th className="wd-lg-20p text-center">Section</th>
                              {/* <th className="wd-lg-20p text-center">Student</th> */}
                            </>
                          }
                          {ftype == 3 &&
                            <th className="wd-lg-20p text-center">Stage</th>
                          }
                          <th className="wd-lg-20p text-center">Fee Amount</th>
                          <th className="wd-lg-20p text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filterProduct.map((item, index) => (
                          <tr key={index}>
                            {ftype != 3 &&
                              <>
                                <td className="text-center">
                                  <Select
                                    isMulti
                                    options={classOptions}
                                    value={item.class} // Adjust this according to how you manage selected values
                                    onChange={(selectedOptions) =>
                                      handleClassChange(index, selectedOptions)
                                    }
                                    classNamePrefix="select"
                                    placeholder="Select Class"
                                  />
                                  {/* <select
                                className="default-select form-control wide"
                                value={item.class}
                                onChange={(e) => handleClassChange(index, e)}
                              >
                                <option value="" disabled>
                                  Select Class
                                </option>
                                {clist.map((item) => (
                                  <option value={item.value} key={item.value}>
                                    {item.label}
                                  </option>
                                ))}
                              </select> */}
                                  {examerr && !item.class && (
                                    <span className="text-danger">
                                      Class is required
                                    </span>
                                  )}
                                </td>
                                <td className="text-center">
                                  <Select
                                    isMulti
                                    options={sectionOptions}
                                    value={item.sec} // Adjust this according to how you manage selected values
                                    onChange={(selectedOptions) =>
                                      handleSecChange(index, selectedOptions)
                                    }
                                    classNamePrefix="select"
                                    placeholder="Select Sections"
                                  />
                                  {/* <select
                                className="default-select form-control wide"
                                value={item.sec}
                                onChange={(e) => handleSecChange(index, e)}
                              >
                                <option value="" disabled>
                                  Select Section
                                </option>
                                {dlist.map((item) => (
                                  <option value={item.value} key={item.value}>
                                    {item.label}
                                  </option>
                                ))}
                              </select> */}
                                  {examerr &&
                                    (!item.sec || item.sec.length === 0) && (
                                      <span className="text-danger">
                                        Section is required
                                      </span>
                                    )}
                                </td>
                                {/* <td className="text-center">
                              <Select
                                isMulti
                                options={stulist}
                                value={item.stuid} // Adjust this according to how you manage selected values
                                onChange={(selectedOptions) =>
                                  handleStuChange(index, selectedOptions)
                                }
                                classNamePrefix="select"
                                placeholder="Select Student"
                              />
                             
                              {examerr &&
                                (!item.sec || item.sec.length === 0) && (
                                  <span className="text-danger">
                                    Student is required
                                  </span>
                                )}
                            </td> */}
                              </>
                            }
                            {ftype == 3 &&
                              <td className="text-center">
                                <div className="mb-6">
                                  <Select
                                    isMulti
                                    options={stageOptions}
                                    value={item.stgid}
                                    onChange={(selectedOptions) =>
                                      handleStageChange(index, selectedOptions)
                                    }
                                    classNamePrefix="select"
                                    placeholder="Select Stages"
                                  />
                                </div>
                                {examerr && !item.stgid && (
                                  <span className="text-danger">
                                    Stages is required
                                  </span>
                                )}
                              </td>

                            }

                            <td className="text-center">
                              <div className="mb-6">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Fee Amount"
                                  value={item.amt}
                                  onChange={(e) => handleAmtChange(index, e)}
                                />
                              </div>
                              {examerr && !item.amt && (
                                <span className="text-danger">
                                  Amount is required
                                </span>
                              )}
                            </td>
                            <td className="text-center">
                              <div className="mb-6">
                                <button
                                  className="btn-sm btn-danger"
                                  title="Delete"
                                  onClick={() =>
                                    handleRemoveRow(index, item.id)
                                  }
                                >
                                  {" "}
                                  <i className="fa fa-trash"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <hr />
                  <div className="res-right me-4">
                    <button className="btn btn-success" onClick={handleSave}>
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Add Individual Modal */}
      <Modal show={showIndividualModal} onHide={handleCloseIndividualModal} size="lg">
        <Modal.Header>
          <Modal.Title>Add Individual Fee Structure</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Send Push Notification checkbox hidden for individual fee structure
          <div className="mb-3">
            <input
              type="checkbox"
              className="styled-checkbox"
              id="feePushCheckboxInd"
              checked={spushInd}
              onChange={(e) => setSpushInd(e.target.checked)}
            /> Send Push Notification
          </div>
          */}
          <div className="row">
            {localStorage.getItem("Role") === "1" && (
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">
                    Academy <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="default-select"
                    placeholder="Select Academy"
                    value={individualForm.academy}
                    options={aclist}
                    onChange={(value) => handleIndividualFormChange('academy', value)}
                    isSearchable={true}
                    isClearable
                  />
                  {individualFormErrors.academy && (
                    <span className="text-danger">{individualFormErrors.academy}</span>
                  )}
                </div>
              </div>
            )}

            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Academic Year <span className="text-danger">*</span>
                </label>
                <Select
                  className="default-select"
                  placeholder="Select Academic Year"
                  value={alist.find(item => item.value === individualForm.academicYear) || null}
                  options={alist}
                  onChange={(value) => handleIndividualFormChange('academicYear', value ? value.value : '')}
                  isSearchable={true}
                  isClearable
                />
                {individualFormErrors.academicYear && (
                  <span className="text-danger">{individualFormErrors.academicYear}</span>
                )}
              </div>
            </div>

            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Fee Type <span className="text-danger">*</span>
                </label>
                <Select
                  className="default-select"
                  placeholder="Select Fee Type"
                  value={flist.find(item => item.value === individualForm.feeType) || null}
                  options={flist}
                  onChange={(value) => handleIndividualFormChange('feeType', value ? value.value : '')}
                  isSearchable={true}
                  isClearable
                />
                {individualFormErrors.feeType && (
                  <span className="text-danger">{individualFormErrors.feeType}</span>
                )}
              </div>
            </div>

            {/* Conditional fields based on fee type */}
            {individualForm.feeTypeRoute == 3 && (
              // Stage selection for transport fee (fee type 3)
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">
                    Stage <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="default-select"
                    placeholder="Select Stage"
                    value={individualForm.stage}
                    options={individualStageList}
                    onChange={(value) => handleIndividualFormChange('stage', value)}
                    isSearchable={true}
                    isClearable
                  />
                  {individualFormErrors.stage && (
                    <span className="text-danger">{individualFormErrors.stage}</span>
                  )}
                </div>
              </div>


            )}

            <>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">
                    Class <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="default-select"
                    placeholder="Select Class"
                    value={individualForm.class}
                    options={clist}
                    onChange={(value) => handleIndividualFormChange('class', value)}
                    isSearchable={true}
                    isClearable
                  />
                  {individualFormErrors.class && (
                    <span className="text-danger">{individualFormErrors.class}</span>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">
                    Section <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="default-select"
                    placeholder="Select Section"
                    value={individualForm.section}
                    options={dlist}
                    onChange={(value) => handleIndividualFormChange('section', value)}
                    isSearchable={true}
                    isClearable
                    isDisabled={!individualForm.class}
                  />
                  {individualFormErrors.section && (
                    <span className="text-danger">{individualFormErrors.section}</span>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">
                    Student <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="default-select"
                    placeholder="Select Student"
                    value={individualForm.student}
                    options={stulist}
                    onChange={(value) => {
                      handleIndividualFormChange('student', value);
                      if (value) {
                        handleIndividualFormChange('admissionNumber', '');
                      }
                    }}
                    isSearchable={true}
                    isClearable
                    isDisabled={!individualForm.section}
                  />
                  {individualFormErrors.student && (
                    <span className="text-danger">{individualFormErrors.student}</span>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">
                    OR Admission Number <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Admission Number"
                    value={individualForm.admissionNumber}
                    onChange={(e) => {
                      handleIndividualFormChange('admissionNumber', e.target.value);
                      if (e.target.value) {
                        handleIndividualFormChange('student', '');
                      }
                    }}
                    onBlur={(e) => loadadmdetails(e.target.value)}
                  />
                  {individualFormErrors.admissionNumber && (
                    <span className="text-danger">{individualFormErrors.admissionNumber}</span>
                  )}
                </div>
              </div>
            </>

            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Fee Amount <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Fee Amount"
                  value={individualForm.feeAmount}
                  onChange={(e) => {
                    const regex = /^[0-9\b]+$/;
                    if (e.target.value === "" || regex.test(e.target.value)) {
                      handleIndividualFormChange('feeAmount', e.target.value);
                    }
                  }}
                />
                {individualFormErrors.feeAmount && (
                  <span className="text-danger">{individualFormErrors.feeAmount}</span>
                )}
              </div>
            </div>

            <div className="col-md-12">
              <div className="mb-3">
                <label className="form-label d-block">Monthly</label>
                <label style={{ cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    className="styled-checkbox"
                    checked={!!individualForm.monthly}
                    onChange={(e) => {
                      const c = e.target.checked;
                      handleIndividualFormChange("monthly", c);
                      const ayLabel = (alist.find((a) => String(a.value) === String(individualForm.academicYear)) || {}).label || "";
                      if (c && (individualForm.selectedMonths || []).length === 0) {
                        handleIndividualFormChange("selectedMonths", academicMonths(ayLabel).map((o) => o.value));
                      }
                    }}
                  />{" "}
                  Charge every month <span className="text-muted tx-12">(untick any holiday month)</span>
                </label>
                {individualForm.monthly && (() => {
                  const ayLabel = (alist.find((a) => String(a.value) === String(individualForm.academicYear)) || {}).label || "";
                  const monthOpts = academicMonths(ayLabel);
                  const sel = individualForm.selectedMonths || [];
                  if (monthOpts.length === 0) {
                    return <div className="text-danger tx-12 mt-1">Select an academic year first.</div>;
                  }
                  return (
                    <div className="mt-2">
                      <div className="mb-2">
                        <button type="button" className="btn btn-sm btn-success me-2"
                          onClick={() => handleIndividualFormChange("selectedMonths", monthOpts.map((o) => o.value))}>
                          Select all
                        </button>
                        <button type="button" className="btn btn-sm btn-danger"
                          onClick={() => handleIndividualFormChange("selectedMonths", [])}>
                          Clear
                        </button>
                        <span className="text-muted tx-12 ms-2">{sel.length} selected</span>
                      </div>
                      <div className="d-flex flex-wrap" style={{ gap: "6px 16px" }}>
                        {monthOpts.map((m) => (
                          <label key={m.value} style={{ cursor: "pointer", minWidth: "90px" }}>
                            <input
                              type="checkbox"
                              className="styled-checkbox"
                              checked={sel.includes(m.value)}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  handleIndividualFormChange("selectedMonths", [...sel, m.value]);
                                } else {
                                  handleIndividualFormChange("selectedMonths", sel.filter((v) => v !== m.value));
                                }
                              }}
                            /> {m.label}
                          </label>
                        ))}
                      </div>
                    </div>
                  );
                })()}
              </div>
            </div>
          </div>
          {merrormsg && (
            <span className="text-danger">{merrormsg}</span>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseIndividualModal}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleIndividualSubmit}>
            Add Individual
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
